import { useMutation, useQueryClient } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { aceAssignmentKeys } from '../../cache-keys/aceAssignmentKeys';

export function useSetAssignmentApplicationProcessedV3() {
  const api = useAPI();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ace_api.setApplicationProcessedV3(api),
    onSettled: (_, __, { ApplicationID }) => {
      queryClient.invalidateQueries([
        aceAssignmentKeys.application(ApplicationID),
      ]);
      queryClient.invalidateQueries({
        queryKey: [{ ...aceAssignmentKeys.root(), entity: 'agent-assignments' }],
      });
    },
  });
}
